var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3032 11.9561H4.30089C3.95077 11.9561 3.65105 11.8315 3.40173 11.5821C3.1524 11.3328 3.02774 11.0331 3.02774 10.683V1.77095C3.02774 1.42084 3.1524 1.12111 3.40173 0.87179C3.65105 0.622465 3.95077 0.497803 4.30089 0.497803H8.75691L12.5764 4.31725V10.683C12.5764 11.0331 12.4517 11.3328 12.2024 11.5821C11.953 11.8315 11.6533 11.9561 11.3032 11.9561ZM8.12033 4.95382V1.77095H4.30089V10.683H11.3032V4.95382H8.12033ZM1.75459 14.5024C1.40448 14.5024 1.10476 14.3778 0.855433 14.1284C0.606108 13.8791 0.481445 13.5794 0.481445 13.2293V4.31725H1.75459V13.2293H8.75691V14.5024H1.75459Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.2b5af20d2dcc0fb128790dc280fbd645.svg";
export { ForwardRef as ReactComponent };